import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../store';
import Header from '../components/layout/Header';
import Sidebar from '../components/layout/Sidebar';
import Footer from '../components/layout/Footer';
import SearchPage from './SearchPage';
import FavoritesPage from './FavoritesPage';
import TrendingPage from './TrendingPage';
import FeedbackPage from './FeedbackPage';
import AuthModal from '../components/auth/AuthModal';
import ProfileModal from '../components/auth/ProfileModal';
import FavoritesModal from '../components/favorites/FavoritesModal';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const {
    activeTab,
    setActiveTab,
    error,
    clearError
  } = useAppStore();

  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState<'login' | 'register'>('login');
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showFavoritesModal, setShowFavoritesModal] = useState(false);

  // 处理标签切换
  const handleTabChange = (tab: 'search' | 'favorites' | 'trending' | 'feedback' | 'payment') => {
    if (tab === 'feedback') {
      // 导航到反馈页面
      navigate('/feedback');
    } else if (tab === 'payment') {
      // 导航到会员 / 支付页面
      navigate('/payment');
    } else {
      setActiveTab(tab);
    }
  };

  // 处理错误显示
  useEffect(() => {
    if (error) {
      // 过滤掉初始化时的各种错误
      const shouldShowError = !error.includes('加载收藏失败') &&
                             !error.includes('请先登录') &&
                             !error.includes('LOGIN_REQUIRED') &&
                             !error.includes('用户不存在') &&
                             !error.includes('获取用户信息失败') &&
                             !error.includes('Token验证失败');

      if (shouldShowError) {
        console.warn('Home page error:', error);
        // 5秒后自动清除错误
        const timer = setTimeout(() => {
          clearError();
        }, 5000);
        return () => clearTimeout(timer);
      } else {
        // 立即清除不需要显示的错误
        console.log('过滤掉初始化错误:', error);
        clearError();
      }
    }
  }, [error, clearError]);

  const handleShowLogin = () => {
    setAuthMode('login');
    setShowAuthModal(true);
  };

  const handleShowProfile = () => {
    setShowProfileModal(true);
  };

  // 渲染当前活动的页面内容
  const renderActiveContent = () => {
    switch (activeTab) {
      case 'trending':
        return <TrendingPage />;
      case 'search':
        return <SearchPage />;
      case 'favorites':
        return <FavoritesPage />;
      case 'feedback':
        return <FeedbackPage />;
      case 'payment':
        // 付款页面单独有路由，这里默认回到 Trending
        return <TrendingPage />;
      default:
        return <TrendingPage />;
    }
  };

  return (
    <div className="app-layout">
      {/* 左侧边栏 */}
      <Sidebar
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      {/* 主内容区 */}
      <div className="main-content">
        {/* 头部 */}
        <Header
          onShowLogin={handleShowLogin}
          onShowProfile={handleShowProfile}
        />

        {/* 内容区域 */}
        <div className="content-area">
          {renderActiveContent()}
        </div>

        {/* 页脚 */}
        <Footer />
      </div>

      {/* 模态框 */}
      <AuthModal
        show={showAuthModal}
        mode={authMode}
        onHide={() => setShowAuthModal(false)}
        onSwitchMode={(mode) => setAuthMode(mode)}
      />

      <ProfileModal
        show={showProfileModal}
        onHide={() => setShowProfileModal(false)}
      />

      <FavoritesModal
        show={showFavoritesModal}
        onHide={() => setShowFavoritesModal(false)}
      />
    </div>
  );
};

export default HomePage;

